// open modal: only then load iframe
// close modal: then remove iframe
// Why? So that the browser back button continues to work
function stopVideo() {
  if ($('.rw-video-embed iframe').length) {
    $('.rw-video-embed iframe').remove();
  }
}

const toggleModal = (target) => {
  $(target).toggleClass('active');
};

$(document).on('click', '[data-modal]', function () {
  $('.modal.active').removeClass('active');
  const target = $(this).data('modal');
  const unique = $(this).attr('data-modal-unique');

  if (unique) { // if modal has unique id
    toggleModal('#modal--' + target + unique);
  } else {
    toggleModal('#modal--' + target);
  }

  // disable scroll
  $('html, body').css('overflow', 'hidden');

  // open modal: only then load iframe
  // close modal: then remove iframe
  // Why? So that the browser back button continues to work
  if ($('.modal.active .rw-video-embed').length) {
    $('.modal.active .rw-video-embed').append('<iframe src="'+$('.modal.active .rw-video-embed .d-none').attr('src')+'" allowfullscreen frameBorder="0"></iframe>');
  }

  if (!target.length) {
    return;
  }
});

$('.modal__close').on('click', function () {
  stopVideo();
  let modal = $(this).parent().parent();
  $('html, body').css('overflow', '');
  toggleModal(modal);
});

$(document).keydown(function (e) {
  if (e.keyCode == 27) {
    if ($('.modal.active').length != 0) {
      stopVideo();
      $('html, body').css('overflow', '');
      toggleModal('.active');
    }
  }
});
